"use strict";

import _ from "lodash";

class InputSanitizer {
  static containsShowit(str) {
    return /(showit|sh0wit|show1t|sh0w1t|5howit)/i.test(str);
  }

  static _removePHP(/** String **/ value) {
    if (!_.isEmpty(value)) {
      value = value.replace(/<\?(php|=)|\?>/gi, "");
    }

    return value;
  }

  static sanitize(/** String **/ value) {
    return InputSanitizer._removePHP(value);
  }

  static sanitizeSVG(/** String **/ value) {
    value = value.replace(/fill="(?!none).*?"/gi, "");
    value = value.replace(/style=".*?"/gi, "");
    value = value.replace(/id=".*?"/gi, "");
    value = value.replace(/version=".*?"/gi, "");
    value = value.replace(/class=".*?"/gi, "");
    value = value.replace(/title=".*?"/gi, "");
    value = value.replace(/ x=".*?"/gi, " ");
    value = value.replace(/ y=".*?"/gi, " ");
    value = value.replace(/height=".*?"/gi, "");
    value = value.replace(/ width=".*?"/gi, "");
    value = value.replace(/xmlns\:xlink=".*?"/gi, "");
    value = value.replace(/enable-background=".*?"/gi, "");
    value = value.replace(/xml\:space=".*?"/gi, "");
    value = value.replace(/\<style[\s\S]*?\<\/style\>/gi, "");

    return value;
  }
}

export default InputSanitizer;
